import React from 'react'
import styled from 'styled-components'
import { useMoteQrCode } from '@mote/helpers/hooks/business'
import { Block, Button } from '@mote/ui'

export const QrCodeDisplay = props => {
  const {
    containerRef,
    saveImage,
    qrCodeElement,
    qrCodeImageElement,
    renderFor
  } = useMoteQrCode(props)

  return (
    <Root
      align='center'
      margin={renderFor === 'extension' ? '47px 0 0 0' : '0 0 0 0'}
      gap={renderFor === 'extension' ? 31 : 13}
      ref={containerRef}
    >
      {qrCodeImageElement}
      {qrCodeElement}
      <Button text='Save image' onClick={saveImage} />
    </Root>
  )
}

const Root = styled(Block)`
  position: relative;
`
